const OverzichtStyle = {
  right: {
    textAlign: "right",
  },
};

export default OverzichtStyle;
